import { c as _c } from "react-compiler-runtime";
import { useCallback, useReducer } from 'react';
import taskDeleteReducer, { initialState } from 'collaboration-sidebar/reducers/taskDelete';
import { MSG_TYPE_CONFIRM_DELETE_TASK, MSG_TYPE_DELETE_TASK, MSG_TYPE_DELETE_TASK_FAILURE, MSG_TYPE_DELETE_TASK_SUCCESS, MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL, MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL } from 'collaboration-sidebar/constants/IFrameMessageTypes';
export default function useTaskDeleteModal(t0) {
  "use memo";

  const $ = _c(12);
  const {
    sendMessageRef,
    isSendMessageReady
  } = t0;
  const [state, dispatch] = useReducer(taskDeleteReducer, initialState);
  const {
    show,
    taskId
  } = state;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = t2 => {
      const {
        payload
      } = t2;
      bb2: switch (payload.type) {
        case MSG_TYPE_DELETE_TASK_SUCCESS:
        case MSG_TYPE_DELETE_TASK_FAILURE:
        case MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL:
          {
            dispatch(payload);
            break bb2;
          }
        default:
          {
            dispatch(payload);
          }
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleMessage = t1;
  let t2;
  if ($[1] !== show) {
    t2 = () => {
      if (show) {
        dispatch({
          type: MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL
        });
      }
    };
    $[1] = show;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onClose = t2;
  let t3;
  if ($[3] !== isSendMessageReady || $[4] !== sendMessageRef || $[5] !== show || $[6] !== taskId) {
    t3 = () => {
      if (show && isSendMessageReady && sendMessageRef.current && taskId) {
        sendMessageRef.current(MSG_TYPE_DELETE_TASK, {
          taskId
        });
        dispatch({
          type: MSG_TYPE_CONFIRM_DELETE_TASK
        });
      } else {
        dispatch({
          type: MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL
        });
      }
    };
    $[3] = isSendMessageReady;
    $[4] = sendMessageRef;
    $[5] = show;
    $[6] = taskId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const onDelete = t3;
  let t4;
  if ($[8] !== onClose || $[9] !== onDelete || $[10] !== state) {
    t4 = Object.assign({}, state, {
      handleMessage,
      onClose,
      onDelete
    });
    $[8] = onClose;
    $[9] = onDelete;
    $[10] = state;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}